export default "__VITE_ASSET__CPU6TyQ4__"